import {
  FlexBox,
  SectionLoader,
  Spacer,
} from '@airship-platform/jam-web/components';
import { LeftArrowIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { useProducts } from '../../../data-access';
import DiscountsQueryForm from './DiscountsQueryForm';

const DiscountsQuery: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoadedLookups, isLoadingLookups } = useProducts();

  if (isLoadingLookups && !isLoadedLookups) {
    return <SectionLoader isLoading title={'Fetching discounts...'} />;
  }

  return (
    <FlexBox flexDirection={'column'} gap={3} width={'100%'}>
      <Button
        component={Link}
        to={'..'}
        color={'softGray'}
        startIcon={<LeftArrowIcon width={'1.25rem'} />}
        sx={{ alignSelf: 'flex-start' }}
      >
        Back to products
      </Button>
      <DiscountsQueryForm />
      {children}
      <Spacer height="2rem" />
    </FlexBox>
  );
};

export default DiscountsQuery;
